import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

import FiltersSetsDropdown from 'components/Views/Creative/Drawers/FiltersDrawer/FiltersSetsDropdown';

import FiltersButton from './FiltersButton';

const Container = styled(Space.Compact)`
  display: flex;
`;

function FiltersGroup() {
  return (
    <Container>
      <FiltersSetsDropdown />
      <FiltersButton />
    </Container>
  );
}

export default FiltersGroup;
